import { CloudDone, CloudQueueOutlined } from "@mui/icons-material";
import makeStyles from "@mui/styles/makeStyles";

import clsx from "clsx";

const useStyles = makeStyles(() => {
  return {
    savingSpinner: {
      "&:before": {
        height: 36,
        width: 36,
      },
      position: "absolute",
      top: 4,
      left: -8,
    },
  };
});

function LoadingIndicator({ loading, className }) {
  const classes = useStyles();

  return (
    <div className={clsx("text-success", className)}>
      <div className="position-relative">
        {loading && (
          <div
            className={clsx(classes.savingSpinner, "kt-spinner kt-spinner--v2 kt-spinner--success")}
          />
        )}
        {loading ? <CloudQueueOutlined /> : <CloudDone />}
      </div>
    </div>
  );
}

export default LoadingIndicator;
